// landingPages.js - All 50 landing page definitions
// Tier 1: Educational (30), Tier 2: Data/Research (10), Tier 3: Solution (10)

export const LANDING_PAGES = {
  // =============================================================================
  // TIER 1: EDUCATIONAL (30 pages)
  // =============================================================================

  'medigap-retention-strategies': {
    tier: 1,
    slug: 'medigap-retention-strategies',
    keyword: 'medicare medigap retention strategies',
    title: 'Medicare Medigap Retention Strategies That Actually Work',
    metaTitle: 'Medicare Medigap Retention Strategies | Pro IRP',
    metaDescription: 'Proven strategies for retaining Medicare Supplement clients. Learn why Medigap clients leave and how to keep your book of business intact.',
    publishedDate: '2024-12-10',
    readTime: 9,
    relatedSlugs: ['med-supp-cancellation-reasons', 'book-of-business-retention', 'commission-protection'],
    content: null // Will be populated
  },

  'book-of-business-retention': {
    tier: 1,
    slug: 'book-of-business-retention',
    keyword: 'medicare book of business retention',
    title: 'How to Protect Your Medicare Book of Business',
    metaTitle: 'Medicare Book of Business Retention Guide | Pro IRP',
    metaDescription: 'Your book of business is your livelihood. Learn practical strategies to protect and grow your Medicare client base year after year.',
    publishedDate: '2024-12-10',
    readTime: 10,
    relatedSlugs: ['commission-protection', 'book-valuation-retention', 'year-round-retention'],
    content: null
  },

  'dual-snp-retention-strategies': {
    tier: 1,
    slug: 'dual-snp-retention-strategies',
    keyword: 'dual eligible snp retention strategies',
    title: 'Dual Eligible & SNP Client Retention: A Complete Guide',
    metaTitle: 'Dual Eligible SNP Retention Strategies | Pro IRP',
    metaDescription: 'Dual eligible and SNP clients have unique needs. Learn retention strategies that address their specific challenges and reduce churn.',
    publishedDate: '2024-12-10',
    readTime: 11,
    relatedSlugs: ['chronic-condition-retention', 'ma-disenrollment-analysis', 'compliance-friendly-outreach'],
    content: null
  },

  'ma-vs-medigap-switching': {
    tier: 1,
    slug: 'ma-vs-medigap-switching',
    keyword: 'medicare advantage vs medigap switching',
    title: 'Why Clients Switch Between Medicare Advantage and Medigap',
    metaTitle: 'Medicare Advantage vs Medigap Switching Patterns | Pro IRP',
    metaDescription: 'Understanding why clients switch between MA and Medigap helps you anticipate their needs. Learn the patterns and how to respond.',
    publishedDate: '2024-12-10',
    readTime: 10,
    relatedSlugs: ['medigap-retention-strategies', 'med-supp-cancellation-reasons', 'ppo-vs-hmo-retention'],
    content: null
  },

  'star-ratings-retention': {
    tier: 1,
    slug: 'star-ratings-retention',
    keyword: 'medicare star ratings and retention',
    title: 'How Medicare Star Ratings Affect Client Retention',
    metaTitle: 'Medicare Star Ratings and Client Retention | Pro IRP',
    metaDescription: 'Star ratings impact everything from client satisfaction to SEP eligibility. Learn how to use star ratings in your retention strategy.',
    publishedDate: '2024-12-10',
    readTime: 8,
    relatedSlugs: ['ma-disenrollment-analysis', 'member-satisfaction-retention', 'network-change-alerts'],
    content: null
  },

  'formulary-change-alerts': {
    tier: 1,
    slug: 'formulary-change-alerts',
    keyword: 'medicare pharmacy and formulary change alerts',
    title: 'Formulary Changes: The Hidden Retention Killer',
    metaTitle: 'Medicare Formulary Change Alerts & Retention | Pro IRP',
    metaDescription: 'Formulary changes blindside clients and agents alike. Learn how to stay ahead of drug coverage changes and prevent unnecessary churn.',
    publishedDate: '2024-12-10',
    readTime: 8,
    relatedSlugs: ['chronic-condition-retention', 'network-change-alerts', 'plan-change-monitoring'],
    content: null
  },

  'premium-increase-retention': {
    tier: 1,
    slug: 'premium-increase-retention',
    keyword: 'medicare premium increase retention strategy',
    title: 'How to Retain Clients Through Premium Increases',
    metaTitle: 'Medicare Premium Increase Retention Strategy | Pro IRP',
    metaDescription: 'Premium increases don\'t have to mean lost clients. Learn how to communicate rate changes and keep clients from shopping around.',
    publishedDate: '2024-12-10',
    readTime: 9,
    relatedSlugs: ['aep-retention-playbook', 'communication-workflows', 'member-satisfaction-retention'],
    content: null
  },

  'med-supp-cancellation-reasons': {
    tier: 1,
    slug: 'med-supp-cancellation-reasons',
    keyword: 'medicare supplemental insurance cancellation reasons',
    title: 'Why Medicare Supplement Clients Cancel (And How to Prevent It)',
    metaTitle: 'Medicare Supplement Cancellation Reasons | Pro IRP',
    metaDescription: 'Understanding why Med Supp clients cancel is the first step to preventing it. Learn the top reasons and proven prevention strategies.',
    publishedDate: '2024-12-10',
    readTime: 10,
    relatedSlugs: ['medigap-retention-strategies', 'premium-increase-retention', 'ma-vs-medigap-switching'],
    content: null
  },

  'aep-retention-playbook': {
    tier: 1,
    slug: 'aep-retention-playbook',
    keyword: 'medicare aep retention playbook',
    title: 'The AEP Retention Playbook: Keep Clients While Everyone Else Is Selling',
    metaTitle: 'Medicare AEP Retention Playbook | Pro IRP',
    metaDescription: 'AEP is when you\'re most likely to lose clients. This playbook shows you how to play defense while competitors focus only on offense.',
    publishedDate: '2024-12-10',
    readTime: 12,
    relatedSlugs: ['oep-retention-strategy', 'year-round-retention', 'communication-workflows'],
    content: null
  },

  'oep-retention-strategy': {
    tier: 1,
    slug: 'oep-retention-strategy',
    keyword: 'medicare oep retention strategy',
    title: 'OEP Retention Strategy: The January-March Survival Guide',
    metaTitle: 'Medicare OEP Retention Strategy | Pro IRP',
    metaDescription: 'Open Enrollment Period is your second chance—or your second risk. Learn how to retain MA clients during the critical first quarter.',
    publishedDate: '2024-12-10',
    readTime: 10,
    relatedSlugs: ['aep-retention-playbook', 'year-round-retention', 'mapd-churn-analytics'],
    content: null
  },

  'year-round-retention': {
    tier: 1,
    slug: 'year-round-retention',
    keyword: 'year round medicare client retention',
    title: 'Year-Round Medicare Client Retention: Beyond Enrollment Periods',
    metaTitle: 'Year-Round Medicare Client Retention | Pro IRP',
    metaDescription: 'Retention isn\'t a seasonal activity. Learn how to maintain client relationships and prevent churn throughout the entire year.',
    publishedDate: '2024-12-10',
    readTime: 11,
    relatedSlugs: ['communication-workflows', 'member-satisfaction-retention', 'onboarding-retention'],
    content: null
  },

  'call-center-retention': {
    tier: 1,
    slug: 'call-center-retention',
    keyword: 'medicare retention for call centers',
    title: 'Medicare Retention Strategies for Call Centers',
    metaTitle: 'Medicare Call Center Retention Strategies | Pro IRP',
    metaDescription: 'Call centers face unique retention challenges at scale. Learn systems and processes that work when you\'re handling thousands of clients.',
    publishedDate: '2024-12-10',
    readTime: 9,
    relatedSlugs: ['large-agency-retention', 'communication-workflows', 'agent-vs-client-churn'],
    content: null
  },

  'small-agency-retention': {
    tier: 1,
    slug: 'small-agency-retention',
    keyword: 'medicare retention for small agencies',
    title: 'Medicare Retention for Small Agencies: Compete With the Big Players',
    metaTitle: 'Medicare Retention for Small Agencies | Pro IRP',
    metaDescription: 'Small agencies can out-retain large competitors with the right approach. Learn retention strategies that leverage your strengths.',
    publishedDate: '2024-12-10',
    readTime: 9,
    relatedSlugs: ['large-agency-retention', 'book-of-business-retention', 'commission-protection'],
    content: null
  },

  'large-agency-retention': {
    tier: 1,
    slug: 'large-agency-retention',
    keyword: 'medicare retention for large agencies',
    title: 'Scaling Medicare Retention at Large Agencies',
    metaTitle: 'Medicare Retention for Large Agencies | Pro IRP',
    metaDescription: 'Large agencies need systems that scale. Learn how to maintain personal touch while managing retention across hundreds of agents.',
    publishedDate: '2024-12-10',
    readTime: 10,
    relatedSlugs: ['small-agency-retention', 'call-center-retention', 'agency-retention-system'],
    content: null
  },

  'agent-retention-training': {
    tier: 1,
    slug: 'agent-retention-training',
    keyword: 'medicare retention training for agents',
    title: 'Medicare Retention Training: What Every Agent Needs to Know',
    metaTitle: 'Medicare Agent Retention Training | Pro IRP',
    metaDescription: 'Most agents are trained to sell, not retain. This guide covers the retention skills that should be part of every agent\'s training.',
    publishedDate: '2024-12-10',
    readTime: 11,
    relatedSlugs: ['persistency-improvement', 'agent-vs-client-churn', 'book-of-business-retention'],
    content: null
  },

  'persistency-improvement': {
    tier: 1,
    slug: 'persistency-improvement',
    keyword: 'medicare persistency improvement strategies',
    title: 'Medicare Persistency Improvement: A Practical Guide',
    metaTitle: 'Medicare Persistency Improvement Strategies | Pro IRP',
    metaDescription: 'Improving persistency means improving your business. Learn actionable strategies to increase client retention rates.',
    publishedDate: '2024-12-10',
    readTime: 10,
    relatedSlugs: ['retention-benchmarks', 'agent-retention-training', 'commission-protection'],
    content: null
  },

  'member-satisfaction-retention': {
    tier: 1,
    slug: 'member-satisfaction-retention',
    keyword: 'medicare member satisfaction and retention',
    title: 'The Connection Between Member Satisfaction and Retention',
    metaTitle: 'Medicare Member Satisfaction & Retention | Pro IRP',
    metaDescription: 'Satisfied clients stay. Learn how to measure and improve member satisfaction to drive better retention outcomes.',
    publishedDate: '2024-12-10',
    readTime: 9,
    relatedSlugs: ['star-ratings-retention', 'communication-workflows', 'onboarding-retention'],
    content: null
  },

  'communication-workflows': {
    tier: 1,
    slug: 'communication-workflows',
    keyword: 'medicare member communication workflows',
    title: 'Medicare Client Communication Workflows That Drive Retention',
    metaTitle: 'Medicare Communication Workflows | Pro IRP',
    metaDescription: 'The right communication at the right time prevents churn. Learn how to build workflows that keep clients engaged and informed.',
    publishedDate: '2024-12-10',
    readTime: 10,
    relatedSlugs: ['year-round-retention', 'compliance-friendly-outreach', 'onboarding-retention'],
    content: null
  },

  'policy-renewal-management': {
    tier: 1,
    slug: 'policy-renewal-management',
    keyword: 'medicare policy renewal management',
    title: 'Medicare Policy Renewal Management: Don\'t Let Renewals Slip Away',
    metaTitle: 'Medicare Policy Renewal Management | Pro IRP',
    metaDescription: 'Policy renewals are retention opportunities. Learn how to manage the renewal process to maximize client retention.',
    publishedDate: '2024-12-10',
    readTime: 8,
    relatedSlugs: ['aep-retention-playbook', 'communication-workflows', 'premium-increase-retention'],
    content: null
  },

  'chronic-condition-retention': {
    tier: 1,
    slug: 'chronic-condition-retention',
    keyword: 'medicare chronic condition member retention',
    title: 'Retaining Medicare Clients with Chronic Conditions',
    metaTitle: 'Medicare Chronic Condition Retention | Pro IRP',
    metaDescription: 'Clients with chronic conditions have complex needs. Learn retention strategies that address their unique healthcare concerns.',
    publishedDate: '2024-12-10',
    readTime: 10,
    relatedSlugs: ['dual-snp-retention-strategies', 'formulary-change-alerts', 'network-change-alerts'],
    content: null
  },

  'network-change-alerts': {
    tier: 1,
    slug: 'network-change-alerts',
    keyword: 'medicare advantage network change alerts',
    title: 'Network Changes: How to Keep Clients When Doctors Leave Plans',
    metaTitle: 'Medicare Network Change Alerts | Pro IRP',
    metaDescription: 'Provider network changes are a top reason clients switch plans. Learn how to stay ahead of changes and retain affected clients.',
    publishedDate: '2024-12-10',
    readTime: 9,
    relatedSlugs: ['formulary-change-alerts', 'plan-change-monitoring', 'chronic-condition-retention'],
    content: null
  },

  'ppo-vs-hmo-retention': {
    tier: 1,
    slug: 'ppo-vs-hmo-retention',
    keyword: 'medicare ppo vs hmo retention patterns',
    title: 'PPO vs HMO: Understanding Retention Patterns by Plan Type',
    metaTitle: 'Medicare PPO vs HMO Retention Patterns | Pro IRP',
    metaDescription: 'PPO and HMO clients churn for different reasons. Learn how plan type affects retention and how to adjust your approach.',
    publishedDate: '2024-12-10',
    readTime: 8,
    relatedSlugs: ['ma-vs-medigap-switching', 'network-change-alerts', 'ma-disenrollment-analysis'],
    content: null
  },

  'commission-protection': {
    tier: 1,
    slug: 'commission-protection',
    keyword: 'medicare commission protection through retention',
    title: 'Protecting Your Medicare Commissions Through Better Retention',
    metaTitle: 'Medicare Commission Protection Through Retention | Pro IRP',
    metaDescription: 'Every lost client is lost revenue. Learn how improving retention directly protects and grows your commission income.',
    publishedDate: '2024-12-10',
    readTime: 9,
    relatedSlugs: ['book-of-business-retention', 'book-valuation-retention', 'lead-vs-retention-roi'],
    content: null
  },

  'book-valuation-retention': {
    tier: 1,
    slug: 'book-valuation-retention',
    keyword: 'medicare book of business valuation and retention',
    title: 'How Retention Affects Your Book of Business Valuation',
    metaTitle: 'Medicare Book Valuation & Retention | Pro IRP',
    metaDescription: 'Planning to sell your book someday? Retention rates dramatically impact valuation. Learn how to build a more valuable business.',
    publishedDate: '2024-12-10',
    readTime: 8,
    relatedSlugs: ['book-of-business-retention', 'commission-protection', 'persistency-improvement'],
    content: null
  },

  'lead-vs-retention-roi': {
    tier: 1,
    slug: 'lead-vs-retention-roi',
    keyword: 'medicare lead vs retention roi comparison',
    title: 'Lead Costs vs Retention ROI: Where Should You Invest?',
    metaTitle: 'Medicare Lead vs Retention ROI | Pro IRP',
    metaDescription: 'Most agents overspend on leads and underspend on retention. See the math that proves retention delivers better ROI.',
    publishedDate: '2024-12-10',
    readTime: 9,
    relatedSlugs: ['commission-protection', 'book-valuation-retention', 'retention-benchmarks'],
    content: null
  },

  'agent-vs-client-churn': {
    tier: 1,
    slug: 'agent-vs-client-churn',
    keyword: 'medicare agent churn vs client churn',
    title: 'Agent Churn vs Client Churn: The Double Retention Challenge',
    metaTitle: 'Medicare Agent Churn vs Client Churn | Pro IRP',
    metaDescription: 'Agencies lose clients when agents leave. Learn strategies to retain both your agents and their clients through transitions.',
    publishedDate: '2024-12-10',
    readTime: 10,
    relatedSlugs: ['large-agency-retention', 'agency-retention-system', 'agent-retention-training'],
    content: null
  },

  'onboarding-retention': {
    tier: 1,
    slug: 'onboarding-retention',
    keyword: 'medicare client onboarding and retention',
    title: 'Client Onboarding: The First Step in Retention',
    metaTitle: 'Medicare Client Onboarding & Retention | Pro IRP',
    metaDescription: 'Retention starts at enrollment. Learn how proper onboarding sets the foundation for long-term client relationships.',
    publishedDate: '2024-12-10',
    readTime: 9,
    relatedSlugs: ['communication-workflows', 'member-satisfaction-retention', 'year-round-retention'],
    content: null
  },

  'compliance-friendly-outreach': {
    tier: 1,
    slug: 'compliance-friendly-outreach',
    keyword: 'medicare compliance friendly retention outreach',
    title: 'Compliance-Friendly Retention Outreach: Stay Legal, Stay Connected',
    metaTitle: 'Medicare Compliance-Friendly Retention Outreach | Pro IRP',
    metaDescription: 'CMS rules limit how you can contact clients. Learn retention outreach strategies that keep you compliant and clients engaged.',
    publishedDate: '2024-12-10',
    readTime: 10,
    relatedSlugs: ['communication-workflows', 'aep-retention-playbook', 'oep-retention-strategy'],
    content: null
  },

  'cross-selling-retention': {
    tier: 1,
    slug: 'cross-selling-retention',
    keyword: 'medicare cross selling and retention',
    title: 'Cross-Selling as a Retention Strategy',
    metaTitle: 'Medicare Cross-Selling & Retention | Pro IRP',
    metaDescription: 'Clients with multiple products are stickier clients. Learn how cross-selling ancillary products improves retention.',
    publishedDate: '2024-12-10',
    readTime: 8,
    relatedSlugs: ['book-of-business-retention', 'commission-protection', 'member-satisfaction-retention'],
    content: null
  },

  'retention-case-studies': {
    tier: 1,
    slug: 'retention-case-studies',
    keyword: 'medicare retention case studies and results',
    title: 'Medicare Retention Case Studies: What Works in the Real World',
    metaTitle: 'Medicare Retention Case Studies | Pro IRP',
    metaDescription: 'Real examples of retention strategies that worked. Learn from agents and agencies who\'ve dramatically improved their retention rates.',
    publishedDate: '2024-12-10',
    readTime: 12,
    relatedSlugs: ['persistency-improvement', 'retention-benchmarks', 'agency-retention-system'],
    content: null
  },

  // =============================================================================
  // TIER 2: DATA & RESEARCH (10 pages)
  // =============================================================================

  'mapd-churn-analytics': {
    tier: 2,
    slug: 'mapd-churn-analytics',
    keyword: 'medicare mapd churn analytics',
    title: 'MAPD Churn Analytics: Understanding the Data Behind Client Loss',
    metaTitle: 'Medicare MAPD Churn Analytics | Pro IRP',
    metaDescription: 'Deep dive into Medicare Advantage churn data. Understand the patterns, causes, and predictive indicators of client attrition.',
    publishedDate: '2024-12-10',
    readTime: 12,
    relatedSlugs: ['mapd-switching-statistics', 'ma-disenrollment-analysis', 'retention-benchmarks'],
    content: null
  },

  'mapd-switching-statistics': {
    tier: 2,
    slug: 'mapd-switching-statistics',
    keyword: 'medicare mapd plan switching statistics',
    title: 'Medicare Plan Switching Statistics: The Numbers You Need to Know',
    metaTitle: 'Medicare MAPD Plan Switching Statistics | Pro IRP',
    metaDescription: 'Current data on Medicare Advantage plan switching rates, patterns, and trends. Updated statistics from CMS and industry sources.',
    publishedDate: '2024-12-10',
    readTime: 10,
    relatedSlugs: ['mapd-churn-analytics', 'retention-benchmarks', 'ma-disenrollment-analysis'],
    content: null
  },

  'ma-disenrollment-analysis': {
    tier: 2,
    slug: 'ma-disenrollment-analysis',
    keyword: 'medicare advantage disenrollment analysis',
    title: 'Medicare Advantage Disenrollment Analysis: Why Members Leave',
    metaTitle: 'Medicare Advantage Disenrollment Analysis | Pro IRP',
    metaDescription: 'Comprehensive analysis of MA disenrollment patterns. Data-driven insights into why members disenroll and when it happens.',
    publishedDate: '2024-12-10',
    readTime: 11,
    relatedSlugs: ['mapd-churn-analytics', 'star-ratings-retention', 'ppo-vs-hmo-retention'],
    content: null
  },

  'retention-benchmarks': {
    tier: 2,
    slug: 'retention-benchmarks',
    keyword: 'medicare retention benchmarks',
    title: 'Medicare Retention Benchmarks: How Do You Compare?',
    metaTitle: 'Medicare Retention Benchmarks by Agency Size | Pro IRP',
    metaDescription: 'Industry benchmarks for Medicare client retention. See how your retention rates compare to peers by agency size and type.',
    publishedDate: '2024-12-10',
    readTime: 9,
    relatedSlugs: ['persistency-improvement', 'mapd-switching-statistics', 'retention-analytics-reporting'],
    content: null
  },

  'retention-analytics-reporting': {
    tier: 2,
    slug: 'retention-analytics-reporting',
    keyword: 'medicare retention analytics and reporting',
    title: 'Medicare Retention Analytics: Metrics That Matter',
    metaTitle: 'Medicare Retention Analytics & Reporting | Pro IRP',
    metaDescription: 'The key metrics for tracking and improving retention. Learn what to measure, how to report it, and what the numbers mean.',
    publishedDate: '2024-12-10',
    readTime: 10,
    relatedSlugs: ['retention-benchmarks', 'mapd-churn-analytics', 'risk-scoring'],
    content: null
  },

  'plan-change-monitoring': {
    tier: 2,
    slug: 'plan-change-monitoring',
    keyword: 'medicare plan change monitoring software',
    title: 'Plan Change Monitoring: Catching Problems Before Clients Leave',
    metaTitle: 'Medicare Plan Change Monitoring | Pro IRP',
    metaDescription: 'How to monitor plan changes that affect your clients. Early warning systems for network, formulary, and benefit changes.',
    publishedDate: '2024-12-10',
    readTime: 9,
    relatedSlugs: ['formulary-change-alerts', 'network-change-alerts', 'retention-dashboard'],
    content: null
  },

  'churn-prediction': {
    tier: 2,
    slug: 'churn-prediction',
    keyword: 'medicare churn prediction software',
    title: 'Medicare Churn Prediction: Using Data to Save Clients',
    metaTitle: 'Medicare Churn Prediction & Analytics | Pro IRP',
    metaDescription: 'How predictive analytics identifies at-risk clients before they leave. The data science behind effective churn prediction.',
    publishedDate: '2024-12-10',
    readTime: 11,
    relatedSlugs: ['risk-scoring', 'mapd-churn-analytics', 'retention-analytics-reporting'],
    content: null
  },

  'risk-scoring': {
    tier: 2,
    slug: 'risk-scoring',
    keyword: 'medicare risk scoring platform',
    title: 'Medicare Risk Scoring: Identifying At-Risk Clients',
    metaTitle: 'Medicare Client Risk Scoring | Pro IRP',
    metaDescription: 'How risk scoring helps you prioritize retention efforts. Understanding the factors that predict client churn.',
    publishedDate: '2024-12-10',
    readTime: 10,
    relatedSlugs: ['churn-prediction', 'retention-analytics-reporting', 'retention-dashboard'],
    content: null
  },

  'agency-retention-system': {
    tier: 2,
    slug: 'agency-retention-system',
    keyword: 'medicare agency retention system',
    title: 'Building a Medicare Agency Retention System',
    metaTitle: 'Medicare Agency Retention System | Pro IRP',
    metaDescription: 'Framework for building systematic retention processes at your agency. People, process, and technology considerations.',
    publishedDate: '2024-12-10',
    readTime: 11,
    relatedSlugs: ['large-agency-retention', 'retention-dashboard', 'retention-analytics-reporting'],
    content: null
  },

  'retention-dashboard': {
    tier: 2,
    slug: 'retention-dashboard',
    keyword: 'medicare retention dashboard software',
    title: 'Medicare Retention Dashboards: Visibility Into Your Book Health',
    metaTitle: 'Medicare Retention Dashboard Software | Pro IRP',
    metaDescription: 'What a retention dashboard should show you. Key visualizations and metrics for monitoring book of business health.',
    publishedDate: '2024-12-10',
    readTime: 8,
    relatedSlugs: ['retention-analytics-reporting', 'risk-scoring', 'agency-retention-system'],
    content: null
  },

  // =============================================================================
  // TIER 3: SOLUTION-AWARE (10 pages)
  // =============================================================================

  'client-retention-software': {
    tier: 3,
    slug: 'client-retention-software',
    keyword: 'medicare client retention software',
    title: 'Medicare Client Retention Software',
    metaTitle: 'Medicare Client Retention Software | Pro IRP',
    metaDescription: 'Purpose-built software for Medicare client retention. AI-powered risk scoring, automated outreach, and retention analytics.',
    publishedDate: '2024-12-10',
    readTime: 8,
    relatedSlugs: ['agent-retention-platform', 'crm-for-retention', 'ai-retention-platform'],
    content: null
  },

  'agent-retention-platform': {
    tier: 3,
    slug: 'agent-retention-platform',
    keyword: 'medicare agent retention platform',
    title: 'Medicare Agent Retention Platform',
    metaTitle: 'Medicare Agent Retention Platform | Pro IRP',
    metaDescription: 'The retention platform built by Medicare agents, for Medicare agents. Finally, tools designed for how you actually work.',
    publishedDate: '2024-12-10',
    readTime: 8,
    relatedSlugs: ['client-retention-software', 'crm-for-retention', 'outreach-automation'],
    content: null
  },

  'ma-retention-tool': {
    tier: 3,
    slug: 'ma-retention-tool',
    keyword: 'medicare advantage retention tool',
    title: 'Medicare Advantage Retention Tool',
    metaTitle: 'Medicare Advantage Retention Tool | Pro IRP',
    metaDescription: 'Specialized tools for retaining Medicare Advantage clients. Risk monitoring, automated touchpoints, and MA-specific workflows.',
    publishedDate: '2024-12-10',
    readTime: 8,
    relatedSlugs: ['client-retention-software', 'churn-prediction', 'outreach-automation'],
    content: null
  },

  'fmo-retention-software': {
    tier: 3,
    slug: 'fmo-retention-software',
    keyword: 'medicare fmo retention software',
    title: 'Medicare FMO Retention Software',
    metaTitle: 'Medicare FMO Retention Software | Pro IRP',
    metaDescription: 'Enterprise retention software for FMOs. Help your downline agents retain more clients with centralized tools and reporting.',
    publishedDate: '2024-12-10',
    readTime: 9,
    relatedSlugs: ['large-agency-retention', 'agency-retention-system', 'client-retention-software'],
    content: null
  },

  'crm-for-retention': {
    tier: 3,
    slug: 'crm-for-retention',
    keyword: 'medicare crm for retention',
    title: 'Medicare CRM Built for Retention',
    metaTitle: 'Medicare CRM for Retention | Pro IRP',
    metaDescription: 'Most CRMs focus on sales. This one focuses on keeping the clients you\'ve already won. A CRM designed around retention.',
    publishedDate: '2024-12-10',
    readTime: 9,
    relatedSlugs: ['client-retention-software', 'client-engagement-system', 'retention-dashboard'],
    content: null
  },

  'ai-retention-platform': {
    tier: 3,
    slug: 'ai-retention-platform',
    keyword: 'ai medicare retention platform',
    title: 'AI-Powered Medicare Retention Platform',
    metaTitle: 'AI Medicare Retention Platform | Pro IRP',
    metaDescription: 'Artificial intelligence that predicts which clients will leave before they do. Smart automation that knows when to reach out.',
    publishedDate: '2024-12-10',
    readTime: 9,
    relatedSlugs: ['churn-prediction', 'risk-scoring', 'client-retention-software'],
    content: null
  },

  'outreach-automation': {
    tier: 3,
    slug: 'outreach-automation',
    keyword: 'medicare agent outreach automation',
    title: 'Medicare Outreach Automation',
    metaTitle: 'Medicare Agent Outreach Automation | Pro IRP',
    metaDescription: 'Automated outreach that feels personal. The right message to the right client at the right time, without the manual work.',
    publishedDate: '2024-12-10',
    readTime: 8,
    relatedSlugs: ['communication-workflows', 'annual-review-automation', 'compliance-friendly-outreach'],
    content: null
  },

  'annual-review-automation': {
    tier: 3,
    slug: 'annual-review-automation',
    keyword: 'medicare annual review automation',
    title: 'Medicare Annual Review Automation',
    metaTitle: 'Medicare Annual Review Automation | Pro IRP',
    metaDescription: 'Automate your annual review process. Systematic outreach that ensures every client gets the attention they need before AEP.',
    publishedDate: '2024-12-10',
    readTime: 8,
    relatedSlugs: ['aep-retention-playbook', 'outreach-automation', 'policy-renewal-management'],
    content: null
  },

  'client-engagement-system': {
    tier: 3,
    slug: 'client-engagement-system',
    keyword: 'medicare client engagement system',
    title: 'Medicare Client Engagement System',
    metaTitle: 'Medicare Client Engagement System | Pro IRP',
    metaDescription: 'Keep clients engaged year-round, not just during enrollment periods. A complete system for ongoing client relationships.',
    publishedDate: '2024-12-10',
    readTime: 8,
    relatedSlugs: ['year-round-retention', 'communication-workflows', 'crm-for-retention'],
    content: null
  },

  'lapse-prevention-software': {
    tier: 3,
    slug: 'lapse-prevention-software',
    keyword: 'medicare lapse prevention software',
    title: 'Medicare Lapse Prevention Software',
    metaTitle: 'Medicare Lapse Prevention Software | Pro IRP',
    metaDescription: 'Prevent policy lapses before they happen. Early warning systems and automated interventions that save at-risk clients.',
    publishedDate: '2024-12-10',
    readTime: 8,
    relatedSlugs: ['risk-scoring', 'churn-prediction', 'client-retention-software'],
    content: null
  }
};

// Helper to get all pages as array
export function getAllLandingPages() {
  return Object.values(LANDING_PAGES);
}

// Helper to get pages by tier
export function getLandingPagesByTier(tier) {
  return Object.values(LANDING_PAGES).filter(page => page.tier === tier);
}

// Helper to get a single page by slug
export function getLandingPage(slug) {
  return LANDING_PAGES[slug] || null;
}

// Helper to get related pages
export function getRelatedPages(slugs) {
  return slugs.map(slug => LANDING_PAGES[slug]).filter(Boolean);
}

export default LANDING_PAGES;
